module.exports = __webpack_public_path__ + "1.4.15-unryo/img/azure.ee4e4bf0.svg";